module.exports = __webpack_public_path__ + "static/img/mouth_01.eed5653.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_01.png
// module id = b3ly
// module chunks = 0